// Shared helpers to decide how a contact/customer's name should be shown.
// Alian (video "Mejoras en proyectos, permisos y reportes", punto F):
// "con los comerciales me es mas facil identificar por el nombre de la
// compania. BuilderCake arriba y la persona de contacto abajo." — for
// commercial accounts the COMPANY is the primary identifier, the person is
// secondary. Residential accounts keep showing the person as primary.

export const isCommercialContact = (c) => {
  if (!c) return false;
  if (c.account_type === 'residential') return false;
  if (c.account_type === 'commercial') return true;
  // Legacy contacts without account_type: infer from company_name presence.
  return !!(c.company_name && c.company_name.trim());
};

/** Returns { primary, secondary } — primary is always shown, secondary only when non-empty. */
export const contactDisplayName = (c) => {
  if (!c) return { primary: '-', secondary: '' };
  const person = `${c.first_name || ''} ${c.last_name || ''}`.trim();
  const company = (c.company_name || '').trim();
  if (isCommercialContact(c) && company) {
    return { primary: company, secondary: person && person !== company ? person : '' };
  }
  return {
    primary: person || company || c.email || c.phone || '-',
    secondary: person && company && person !== company ? company : '',
  };
};

/** Single-line label — for dropdowns/selects where only one line fits. */
export const contactPrimaryLabel = (c) => contactDisplayName(c).primary;
